import { enqueueAutoTagTables } from "@/apis/table/route";
import queries from "@/queries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { useWorkbookId } from "../use-workbook";
import { notifyAutoTagStartFailure } from "./auto-tag-error";

/**
 * 선택한 표들의 오토태깅을 표당 Cloud Task 로 백그라운드 enqueue.
 *
 * 이미 완료/실패한 표는 서버가 PENDING 으로 리셋하므로 재시도도 같은 경로를 쓴다.
 * 진행상황은 `useAutoTagStatus` 폴링으로 노출하므로 여기서는 시작 트리거만 담당한다.
 */
export const useAutoTagTables = () => {
  const { data: workbookId } = useWorkbookId();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationKey: ["auto-tag-tables", workbookId],
    mutationFn: async (tableIds: string[]) => {
      if (!workbookId) throw new Error("Workbook ID is not found");
      return enqueueAutoTagTables(workbookId, tableIds);
    },
    onSuccess: (data) => {
      if (!workbookId) return;
      toast.success(`표 ${data.enqueued}개의 오토태깅을 시작했습니다.`);
      // promise 반환 → status refetch(PENDING 도착)까지 isPending 유지(깜빡임 방지).
      return queryClient.invalidateQueries(
        queries.workbook(workbookId)._ctx.autoTagStatus(),
      );
    },
    onError: notifyAutoTagStartFailure,
  });

  return { mutate, isPending };
};
